require('./conclusion.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class ConclusionComponent {
  constructor() {
    this.controller = ConclusionController;
    this.template = require('./conclusion.html');
  }
}

// @ngInject
class ConclusionController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.CONCLUSION));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.conclusion ? state.demande.data.conclusion.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne,
          termine: state.demande.data.reamenagement ? state.demande.data.reamenagement.source : null
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateConclusion(this.data, true));
  }

  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateConclusion(this.data));
  }

}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/conclusion/conclusion.component.js